const deviceModel = {
  'pages.material.material.device-model.addDevice': '',
}
export default deviceModel
